export enum NoticeLevelEnum {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR'
}
